import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { Location } from '@angular/common';

@Component({
  selector: 'app-view-farmer-application',
  templateUrl: './view-farmer-application.component.html',
  styleUrls: ['./view-farmer-application.component.scss']
})
export class ViewFarmerApplicationComponent implements OnInit {

  userID: any;
  appId: any;
  
  constructor(
    private route: ActivatedRoute,
    private activityRecordService: ActivityRecordService,
    private cryptoJsService: CryptoJsService,
    private location: Location,
  ) { }

  ngOnInit(): void {

    this.route.queryParams.subscribe(params => {
      const encryptedMobile = params['appId'];
      if (encryptedMobile) {
        this.appId = this.cryptoJsService.DecryptData(encryptedMobile);
      }else{
        setTimeout(()=> this.onClickBack(), 1300);
      }
    });

    // this.appId = this.cryptoJsService.DecryptData(this.route.snapshot.paramMap.get('appId'));

    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.userID = JSON.parse(payload)?.sub;
    this.activityRecordService.activityRecord(this.userID, 'View Farmer Application', this.appId, new Date(), 'Success');
  }

  onClickBack() {
    this.location.back();
  }
}
